import { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { history } from '../helpers';
import { startPermissionWatcher } from '../utils/permissionWatcher';

export { PrivateRoute };

function PrivateRoute({ children }) {
    const authUser = localStorage.getItem('customer-portal');

    // Starts the mid-session permission-change watcher (see
    // utils/permissionWatcher.js) — idempotent, so it's harmless that every
    // PrivateRoute instance that mounts calls it, not just the first one.
    useEffect(() => {
        if (authUser) startPermissionWatcher();
    }, [authUser]);

    if (!authUser) {
        // not logged in so redirect to login page with the return url
        return <Navigate to="/" state={{ from: history.location }} />
    }

    // authorized so return child components
    return children;
}